import { useEffect } from 'react';

/**
 * While `open`: Esc calls `onClose` and the page behind is frozen (body
 * scroll lock). Shared by the modal Dialog and the phone nav drawer.
 */
export function useDismissableOverlay(open: boolean, onClose: () => void): void {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);
}
